import { ITranslationList } from ".";

export const list: ITranslationList = new Map([
  ["Premium", "Premium"],
  ["What are you looking for?", "What are you looking for?"],
  ["Home page", "Home page"],
  ["Menu", "Menu"],
  ["Search", "Search"],
  ["User menu", "User menu"],
  ["Back", "Back"],
  ["Clear search", "Clear search"],
  ["Cancel", "Cancel"],
  ["Popular", "Popular"],
  ["History", "History"],
  ["Suggestions", "Suggestions"],
  ["Shopping List", "Shopping List"],
  ["Close Menu", "Close Menu"],
  ["Only available in Premium Subscriptions", "Only available in Premium Subscriptions"],
  ["Header", "Header"],
  ["You have items in the Shopping List", "You have items in the Shopping List"],
  ["DD Pro", "DD Pro"],
  ["Access admin dashboard", "Access admin dashboard"],
  ["Challenges", "Programs"],
  ["Trending", "Trending"],
  ["My tracking", "My tracking"]
]);
